import { ChartData, ChartOptions } from "chart.js";
import { TFunction } from "react-i18next";
import { MatchPhone } from "refsix-js-models";
import { COLORS } from "../../../utils/colors";

export const goalsAndAssists = (match: MatchPhone): [number, number] => [
    match.stats?.myGoalsTotal || 0,
    match.stats?.myAssistsTotal || 0,
];

export function getGoalsChartData(
    matches: MatchPhone[],
    t: TFunction
): ChartData<"bar", number[]> {
    const dataset = (index: 0 | 1, label: string, color: string) => ({
        label,
        data: matches.map((match) => goalsAndAssists(match)[index]),
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
    });

    return {
        labels: matches.map(
            (match) => `${match.homeTeamShort} - ${match.awayTeamShort}`
        ),
        datasets: [
            dataset(0, t("editMatch.claimRack.goals"), COLORS.green),
            dataset(1, t("editMatch.claimRack.assists"), COLORS.yellow),
        ],
    };
}

export function getGoalsBarOptions(t: TFunction): ChartOptions<"bar"> {
    return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: { maxRotation: 80, minRotation: 80, color: "white" },
                stacked: true,
            },
            y: {
                title: {
                    display: true,
                    text: t("stats.stats.goals.involvements"),
                    color: "white",
                },
                ticks: { color: "white", precision: 0 },
                beginAtZero: true,
                stacked: true,
            },
        },
        interaction: { mode: "index" },
        plugins: {
            legend: {
                position: "bottom" as const,
                display: true,
                labels: { boxWidth: 12 },
            },
        },
    };
}

export const goalsPerMatch = (
    goals: number,
    assists: number,
    matchesTotal = 0
): string =>
    (matchesTotal > 0 ? (goals + assists) / matchesTotal : 0).toFixed(2);

export const contributionLabel = (goals: number, assists: number): string =>
    [goals && `${goals}G`, assists && `${assists}A`].filter(Boolean).join(" ");
